// extracted by mini-css-extract-plugin
export var completionBody = "_d9-2";
export var completionCard = "_d9-0";
export var completionFooter = "_d9-3";
export var completionTitle = "_d9-1";